module.exports = __webpack_public_path__ + "fb8d2abd5b1ec3f67b707edd5a110024.jpg";